import axios from 'axios'
import {config} from '../../main.js'

export default {
  getLines () {
    return axios.get(config.transdata_api.endpoints.lines)
        .then(response => {
          return response.data
        })
  }
}



// WEBPACK FOOTER //
// ./services/api/transdata.js